import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-reject-view',
  templateUrl: './agent-reject-view.component.html',
  styleUrls: ['./agent-reject-view.component.scss'],
})
export class AgentRejectViewComponent extends BaseComponent<AgentService> implements OnInit {
  constructor(agentService: AgentService, public settingService: SettingService) {
    super(agentService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  tabClose() {
    window.close();
  }
}
